/* eslint-disable react/display-name */
import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import CodeBlock from './CodeBlock';

export const defaultOptions = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: ({ data }) => {
      const { gatsbyImageData, title, description } = data.target;
      if (!gatsbyImageData) {
        // asset is not an image
        return null;
      }
      return <GatsbyImage image={gatsbyImageData} alt={description || title} />;
    },
    [BLOCKS.EMBEDDED_ENTRY]: ({ data }) => {
      switch (data.target?.__typename) {
        case 'ContentfulEmbeddedSnippet':
          return (
            <div
              className="richtext-flex-center embedded-media"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: data.target.embeddedCodeSnippet.embeddedCodeSnippet,
              }}
            />
          );

        case 'ContentfulCodeBlock':
          return (
            <CodeBlock
              title={data.target.title}
              markdown={data.target.codeBlock.codeBlock}
            />
          );

        default:
          return null;
      }
    },
    [INLINES.HYPERLINK]: ({ data }, children) => (
      <a href={data.uri} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
  },
  renderText: (text) =>
    text
      .split('\n')
      .reduce(
        (children, textSegment, index) => [
          ...children,
          index > 0 && <br key={index} />,
          textSegment,
        ],
        []
      ),
};

export default function RichText({ content }) {
  return (
    <div className="rich-text">
      {content ? renderRichText(content, defaultOptions) : null}
    </div>
  );
}
